import React, { Fragment, useState } from "react";
import Modal from "react-modal";

export default ({
  children,
  onRequestClose,
  wrapperClassname = "ReactModalPortal",
  ...props
}) => {
  const [isActivated, setisActivated] = useState(false);
  const [isHovered, setisHovered] = useState(false);
  return (
    <Modal {...props} portalClassName={wrapperClassname ?? "ReactModalPortal"}>
      <div className={"ReactModal__Content__Wrapper"}>
        {onRequestClose && (
          <div
            className={"btn-close-modal"}
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setisActivated(true);
              onRequestClose();
            }}
            onMouseOver={() => {
              setisHovered(() => true);
            }}
            onMouseOut={() => {
              setisHovered(() => false);
            }}
          >
            {!!isActivated ? (
              <Fragment>
                {!isHovered ? (
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_3502_2156"
                      style={{
                        maskType: "luminance",
                      }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="36"
                      height="36"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_3502_2156)">
                      <rect
                        x="-6.10352e-05"
                        width="36"
                        height="36"
                        fill="#E8EBEB"
                      />
                      <path
                        d="M34.9999 18C34.9999 27.3888 27.3888 35 17.9999 35C8.6111 35 0.999939 27.3888 0.999939 18C0.999939 8.61116 8.6111 1 17.9999 1C27.3888 1 34.9999 8.61116 34.9999 18Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.5858 18L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L18 16.5858L23.2929 11.2929C23.6834 10.9024 24.3166 10.9024 24.7071 11.2929C25.0976 11.6834 25.0976 12.3166 24.7071 12.7071L19.4142 18L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L18 19.4142L12.7071 24.7071C12.3166 25.0976 11.6834 25.0976 11.2929 24.7071C10.9024 24.3166 10.9024 23.6834 11.2929 23.2929L16.5858 18Z"
                        fill="#42526E"
                      />
                      <mask
                        id="mask1_3502_2156"
                        style={{
                          maskType: "luminance",
                        }}
                        maskUnits="userSpaceOnUse"
                        x="11"
                        y="11"
                        width="14"
                        height="14"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M16.5858 18L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L18 16.5858L23.2929 11.2929C23.6834 10.9024 24.3166 10.9024 24.7071 11.2929C25.0976 11.6834 25.0976 12.3166 24.7071 12.7071L19.4142 18L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L18 19.4142L12.7071 24.7071C12.3166 25.0976 11.6834 25.0976 11.2929 24.7071C10.9024 24.3166 10.9024 23.6834 11.2929 23.2929L16.5858 18Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask1_3502_2156)">
                        <rect
                          x="6"
                          y="6"
                          width="24"
                          height="24"
                          fill="#00C3FF"
                        />
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_3502_2156"
                      style={{
                        maskType: "luminance",
                      }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="36"
                      height="36"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_3502_2156)">
                      <rect
                        x="-6.10352e-05"
                        width="36"
                        height="36"
                        fill="#E8EBEB"
                      />
                      <path
                        d="M34.9999 18C34.9999 27.3888 27.3888 35 17.9999 35C8.6111 35 0.999939 27.3888 0.999939 18C0.999939 8.61116 8.6111 1 17.9999 1C27.3888 1 34.9999 8.61116 34.9999 18Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.5858 18L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L18 16.5858L23.2929 11.2929C23.6834 10.9024 24.3166 10.9024 24.7071 11.2929C25.0976 11.6834 25.0976 12.3166 24.7071 12.7071L19.4142 18L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L18 19.4142L12.7071 24.7071C12.3166 25.0976 11.6834 25.0976 11.2929 24.7071C10.9024 24.3166 10.9024 23.6834 11.2929 23.2929L16.5858 18Z"
                        fill="#42526E"
                      />
                      <mask
                        id="mask1_3502_2156"
                        style={{
                          maskType: "luminance",
                        }}
                        maskUnits="userSpaceOnUse"
                        x="11"
                        y="11"
                        width="14"
                        height="14"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M16.5858 18L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L18 16.5858L23.2929 11.2929C23.6834 10.9024 24.3166 10.9024 24.7071 11.2929C25.0976 11.6834 25.0976 12.3166 24.7071 12.7071L19.4142 18L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L18 19.4142L12.7071 24.7071C12.3166 25.0976 11.6834 25.0976 11.2929 24.7071C10.9024 24.3166 10.9024 23.6834 11.2929 23.2929L16.5858 18Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask1_3502_2156)">
                        <rect
                          x="6"
                          y="6"
                          width="24"
                          height="24"
                          fill="#689AB9"
                        />
                      </g>
                    </g>
                  </svg>
                )}
              </Fragment>
            ) : (
              <Fragment>
                {!isHovered ? (
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_3502_2156"
                      style={{
                        maskType: "luminance",
                      }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="36"
                      height="36"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_3502_2156)">
                      <rect
                        x="-6.10352e-05"
                        width="36"
                        height="36"
                        fill="#E8EBEB"
                      />
                      <path
                        d="M34.9999 18C34.9999 27.3888 27.3888 35 17.9999 35C8.6111 35 0.999939 27.3888 0.999939 18C0.999939 8.61116 8.6111 1 17.9999 1C27.3888 1 34.9999 8.61116 34.9999 18Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.5858 18L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L18 16.5858L23.2929 11.2929C23.6834 10.9024 24.3166 10.9024 24.7071 11.2929C25.0976 11.6834 25.0976 12.3166 24.7071 12.7071L19.4142 18L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L18 19.4142L12.7071 24.7071C12.3166 25.0976 11.6834 25.0976 11.2929 24.7071C10.9024 24.3166 10.9024 23.6834 11.2929 23.2929L16.5858 18Z"
                        fill="#42526E"
                      />
                      <mask
                        id="mask1_3502_2156"
                        style={{
                          maskType: "luminance",
                        }}
                        maskUnits="userSpaceOnUse"
                        x="11"
                        y="11"
                        width="14"
                        height="14"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M16.5858 18L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L18 16.5858L23.2929 11.2929C23.6834 10.9024 24.3166 10.9024 24.7071 11.2929C25.0976 11.6834 25.0976 12.3166 24.7071 12.7071L19.4142 18L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L18 19.4142L12.7071 24.7071C12.3166 25.0976 11.6834 25.0976 11.2929 24.7071C10.9024 24.3166 10.9024 23.6834 11.2929 23.2929L16.5858 18Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask1_3502_2156)">
                        <rect
                          x="6"
                          y="6"
                          width="24"
                          height="24"
                          fill="#121212"
                        />
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_3502_2156"
                      style={{
                        maskType: "luminance",
                      }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="36"
                      height="36"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_3502_2156)">
                      <rect
                        x="-6.10352e-05"
                        width="36"
                        height="36"
                        fill="#E8EBEB"
                      />
                      <path
                        d="M34.9999 18C34.9999 27.3888 27.3888 35 17.9999 35C8.6111 35 0.999939 27.3888 0.999939 18C0.999939 8.61116 8.6111 1 17.9999 1C27.3888 1 34.9999 8.61116 34.9999 18Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.5858 18L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L18 16.5858L23.2929 11.2929C23.6834 10.9024 24.3166 10.9024 24.7071 11.2929C25.0976 11.6834 25.0976 12.3166 24.7071 12.7071L19.4142 18L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L18 19.4142L12.7071 24.7071C12.3166 25.0976 11.6834 25.0976 11.2929 24.7071C10.9024 24.3166 10.9024 23.6834 11.2929 23.2929L16.5858 18Z"
                        fill="#42526E"
                      />
                      <mask
                        id="mask1_3502_2156"
                        style={{
                          maskType: "luminance",
                        }}
                        maskUnits="userSpaceOnUse"
                        x="11"
                        y="11"
                        width="14"
                        height="14"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M16.5858 18L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L18 16.5858L23.2929 11.2929C23.6834 10.9024 24.3166 10.9024 24.7071 11.2929C25.0976 11.6834 25.0976 12.3166 24.7071 12.7071L19.4142 18L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L18 19.4142L12.7071 24.7071C12.3166 25.0976 11.6834 25.0976 11.2929 24.7071C10.9024 24.3166 10.9024 23.6834 11.2929 23.2929L16.5858 18Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask1_3502_2156)">
                        <rect
                          x="6"
                          y="6"
                          width="24"
                          height="24"
                          fill="#689AB9"
                        />
                      </g>
                    </g>
                  </svg>
                )}
              </Fragment>
            )}
          </div>
        )}
        {children}
      </div>
    </Modal>
  );
};
